package br.com.duoma.duomaproducao

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.togetherWith
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import br.com.duoma.duomaproducao.ui.App
import br.com.duoma.duomaproducao.ui.VIEW_MODEL
import br.com.duoma.duomaproducao.ui.screens.AuthScreen
import br.com.duoma.duomaproducao.ui.theme.ProducaoTheme
import br.com.duoma.duomaproducao.viewmodel.LoginViewModel

@OptIn(ExperimentalComposeUiApi::class)
fun main() {

    val loginVm = LoginViewModel()

    ComposeViewport {
        val state by loginVm.state.collectAsState()
        ProducaoTheme {
            AnimatedContent(
                state.isLoggedIn,
                transitionSpec = {
                    fadeIn(tween(300)) togetherWith fadeOut(tween(300))
                }
            ) {
                if (it)
                    App()
                else AuthScreen(
                    isLoading = state.isLoading, isFailure = state.isFailure, onLogin = {
                        VIEW_MODEL.password = it
                        loginVm.login(it)
                    }
                )
            }
        }
    }
}